export default class AptitudeTestChoice {
  id: number;
  text?: string;

  constructor(entity: AptitudeTestChoice) {
    this.id = entity.id;
    this.text = entity.text || undefined;
  }
}



// WEBPACK FOOTER //
// ./src/entities/AptitudeTestChoice.tsx